export default {
  title: {
    list: '开放接口列表',
    appList: '开放接口 App 列表',
    configResponse: '定制 Response',
    configRequest: 'Job Feed 链接'
  },
  menu: '开放接口管理',
  label: {
    type: '接口类型',
    path: 'URL',
    responseKey: 'Response 名称',
    dataKey: '数据来源',
    isActive: 'On/Off',
    isRequireAuth: '需要验证？',
    name: '名称',
    randomGeneration: '随机生成',
    request: {
      customPath: 'Job Feed 链接',
      fullPath: '预览: {path}',
      customParams: '请求参数设置',
      param: '参数',
      isRequired: '必填',
      defaultValue: '默认值',
      fixedValue: '固定值设为'
    },
    companyId: '公司 ID',
    company: '公司',
    rootCompany: '根公司',
    account: '账号',
    appId: 'App ID',
    securityKey: 'App 密钥',
    appEnv: '环境',
    authType: '验证方式'
  },
  placeholder: {

  },
  btn: {

  },
  message: {
    needSetRequiredParam: '该字段为必填',
    duplicatedCustomPath: '输入的自定义 URL 已被使用',
    duplicatedOpenApiAppId: '同一环境下已存在相同的App ID，请重新输入'
  },
  openApiType: {
    GET_COMPANY_APPLICANT_STATUS_CHANGE_REPORT: '获取公司下求职者状态变更记录',
    SEARCH_JOB_APPLICANT_LIST: '搜索职位下求职者',
    SEARCH_COMPANY_JOB_LIST: '搜索公司下职位'
  },
  authType: {
    BASIC: 'Basic Auth',
    CUSTOM_HTTP_DIGEST_AUTH: '系统默认'
  },
  appEnv: {
    test: '测试',
    prod: '生产'
  }
}
